<template>
  <div v-b-popover.bottomright.hover="{title, content: body, html: true}" class="w-1/3">
    <span class="text-xs underline">
      Calculation Source
    </span>
    <b-icon icon="info-circle" style="color: #b247ff; display:inline"></b-icon>
  </div>
</template>

<script>
import './VueTooltip.scss';
import {VBPopover} from 'bootstrap-vue';

export default {
  name: 'CalcSource',
  directives: {
    'b-popover': VBPopover,
  },
  props: {
    title: String,
    body: String,
    url: String
  }
}
</script>

<style scoped>

</style>
